import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_does_the_fac_define_wage_grades_levels'

export const dataPointDefinition = {
  retracedId: 'how_does_the_fac_define_wage_grades_levels',
  name: 'How does the facility define wage grades/ levels?',
  description:
    'In some countries, wage levels are legally defined (Grade 1, Grade 2, etc. or skilled, semi-skilled). Where not legally defined, the facility may have their own wage grids / wage scales. \r\r\n\r\r\nSelect the best fit for your facility or choose "Other" if your option is not available. \r\r\n\r\r\nThe Tool supports a maximum of 7 wage levels (7 entries for facility data) if you choose Grade or Other. For selection of "Skill" as wage level definition, the Tool only supports 3 wage levels (3 entries for facility data). If you have more wage levels, select "Other" for how the facility defines wage grades/ levels. ',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Grade (1/2/3/4/5/6/7)',
      key: 'GRADE',
      slcpIndex: 1,
      slcpOptionName: 'wagegrade',
    },
    {
      name: 'Skill (skilled/ semi-skilled/ un-skilled)',
      key: 'SKILL_SKILLED_SEMISKILLED_UNSKILLED',
      slcpIndex: 2,
      slcpOptionName: 'wagegrade',
    },
    {
      name: 'Facility does not have wage grade/levels',
      key: 'FAC_DOES_NOT_HAVE_WAGE_GRADELEVELS',
      slcpIndex: 4,
      slcpOptionName: 'wagegrade',
    },
    {
      name: 'Other',
      key: 'OTHER',
      slcpIndex: 3,
      slcpOptionName: 'wagegrade',
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-wag-16f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['GRADE', 'SKILL_SKILLED_SEMISKILLED_UNSKILLED', 'FAC_DOES_NOT_HAVE_WAGE_GRADELEVELS', 'OTHER'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-15',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7610,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
